import { render, staticRenderFns } from "./invoiceAppointment.vue?vue&type=template&id=0616b50c&"
import script from "./invoiceAppointment.vue?vue&type=script&lang=js&"
export * from "./invoiceAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports